<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="60%"
  >
    <div style="overflow-y: auto; padding: 25px">
      <div class="flex">
        {{text}}
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="flex">
          <!-- <el-button @click="visible = false">支付遇到问题</el-button> -->
          <el-button type="primary" @click="Ok">{{buttonText}}</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      data1: [],
      id: '',
      cb: null,
      title: '',
      text: '',
      buttonText: ''
    }
  },
  methods: {
    Ok() {
      this.visible = false
      typeof this.cb === 'function' && this.cb()
    },
    gopage() {
      this.visible = true
      // this.$router.push('/home/first')
    },
  },
}
</script>
<style scoped>
.msak {
  position: absolute;
  z-index: 9998;
  background: #333;
  width: 100%;
  height: 1000px;
  opacity: 0.8;
}
.msak h3 {
  left: 50%;
  top: 50%;
  position: absolute;
  z-index: 9999;
  color: #fff;
}
.flex {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
</style>
